module.exports = __webpack_public_path__ + "static/media/pm_back.47d4f885.svg";